import React, { useEffect, useRef, useState } from 'react';
import { Heart, Sparkles } from 'lucide-react';

const About = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    const node = sectionRef.current;
    if (node) {
      observer.observe(node);
    }

    return () => {
      if (node) {
        observer.unobserve(node);
      }
    };
  }, []);

  return (
    <section className="about-section" ref={sectionRef}>
      <div className="about-container">
        <div className={`about-content ${isVisible ? 'visible' : ''}`}>
          <div className="about-badge">
            <Heart className="w-4 h-4" />
            <span>Our Story</span>
          </div>
          
          <h2 className="about-title">
            Gift Wrapping
            <br />
            <span className="about-title-emphasis">Made Special</span>
          </h2>
          
          <div className="about-text">
            <p>
              <strong>Here's the deal:</strong> You find the perfect gifts but hate the wrapping part? 
              Send us product links OR we'll pickup from your doorstep (yes, we come to you!). 
              Pick a theme or create your own. We'll order (if needed), wrap it beautifully, 
              and deliver it ready to wow. Easy peasy! ✨
            </p>
            
            <div className="about-highlight">
              <Sparkles className="about-highlight-icon" />
              <p className="about-highlight-text">
                Your products + Our magic = Gifts that look way more expensive than they are 💝
              </p>
            </div>
          </div>
        </div>
        
        <div className={`about-images ${isVisible ? 'visible' : ''}`}>
          <div className="about-image-grid">
            <div className="about-image-card large">
              <img 
                src="https://images.unsplash.com/photo-1759563876829-47c081a2afd9?w=600&q=80" 
                alt="Elegant gift presentation"
              />
            </div>
            <div className="about-image-card small top">
              <img 
                src="https://images.unsplash.com/photo-1670540805686-a73a025c0dd1?w=400&q=80" 
                alt="Gift with ribbon"
              />
            </div>
            <div className="about-image-card small bottom">
              <img 
                src="https://images.unsplash.com/photo-1739912061342-280525e3c20f?w=400&q=80" 
                alt="Heart-shaped candles"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
